import React from 'react'
import cn from 'classnames'

import styles from './Button.module.scss'
import { ButtonBase } from '@material-ui/core'
import { isE700Device } from '../VNAndroidSDK/Utils'

const Button = ({
  children,
  className,
  onClick,
  onKeyPress,
  disabled,
  ariaLabel = '',
  tabIndex,
  refProp,
  useMui = false,
  ...props
}) => {
  const classNames = cn(styles.button, className)

  if (useMui) {
    return (
      <ButtonBase
        disableRipple={isE700Device()}
        {...props}
        ref={refProp}
        className={cn(styles.button, { [styles.mui]: useMui }, className)}
        onKeyDown={onKeyPress}
        disabled={disabled}
        tabIndex={tabIndex}
        onClick={onClick}
        aria-label={ariaLabel}
      >
        {children}
      </ButtonBase>
    )
  }
  return (
    <button
      {...props}
      onKeyDown={onKeyPress}
      ref={refProp}
      className={classNames}
      disabled={disabled}
      tabIndex={tabIndex}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {children}
    </button>
  )
}

export default Button
